import type { ColumnDef } from '@tanstack/react-table';
import type { TpbInqueryStatementList } from 'services/openapi';
import React from 'react';
import {
  PointTransactionStatus,
  PointTransactionTypes,
} from 'configs/constants';
import { endOfDay, startOfDay, format } from 'date-fns';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'configs';
import { NumberUtils } from 'modules';
import { formatDateTime } from 'utils/helpers/helpers';

export type FilterType = {
  accountNumber?: string;
  fromTime: string | number;
  toTime: string | number;
  refreshData: number;
  pageSize: number;
  pageIndex: number;
};

export const getInitFilterValues = (urlParams?: any): FilterType => {
  return {
    accountNumber: urlParams?.get('accountNumber') ?? '',
    fromTime:
      urlParams?.get('fromTime') ??
      startOfDay(new Date().setDate(new Date().getDate() - 1)).toUTCString(),
    toTime:
      urlParams?.get('toTime') ??
      endOfDay(new Date().setDate(new Date().getDate() - 1)).toUTCString(),
    refreshData: 0,
    pageSize: Number(urlParams?.get('pageSize') ?? DEFAULT_PAGE_SIZE),
    pageIndex: Number(urlParams?.get('pageIndex') ?? DEFAULT_PAGE_INDEX),
  };
};

// export const initFilterValues: FilterType = {
//   transactionCode: '',
//   transactionStatus: PointTransactionStatus['Tất cả'],
//   transactionType: PointTransactionTypes['Tất cả'],
//   fromTime: startOfDay(new Date()).toUTCString(),
//   toTime: endOfDay(new Date()).toUTCString(),
//   fromUserSearchString: '',
//   toUserSearchString: '',
//   searchDetailContent: '',
//   refreshData: 0,
// };

export const columnsDefined: ColumnDef<TpbInqueryStatementList>[] = [
  {
    header: 'Mã giao dịch truy vấn',
    accessorKey: 'EntryNo',
    cell: (info) => {
      return <div className='textInfo'>{String(info.getValue())}</div>;
    },
  },
  // {
  //   header: 'FTReferenceNo',
  //   accessorKey: 'FTReferenceNo',
  // },
  {
    header: 'Số tài khoản gửi',
    accessorKey: 'AcctNo',
    cell: (info) => {
      if (info.row.original.TransactionAcct.length != 0)
        return (
          <div>
            {String(
              info.row.original.TransactionAcct[
                info.row.original.TransactionAcct.length - 1
              ].AcctNo ?? '',
            )}
          </div>
        );
      else return '';
    },
  },
  {
    header: 'Tên tài khoản',
    accessorKey: 'AcctName',
    cell: (info) => {
      if (info.row.original.TransactionAcct.length != 0)
        return (
          <div>
            {String(
              info.row.original.TransactionAcct[
                info.row.original.TransactionAcct.length - 1
              ].AcctName ?? '',
            )}
          </div>
        );
      else return '';
    },
  },
  {
    header: 'Số tiền',
    accessorKey: 'TransactionAmount',
    cell: (info) => {
      if (info.row.original.TransactionAmount.length != 0)
        return (
          <div className='textInfo'>
            {NumberUtils.toFormatNumber(
              Number(
                info.row.original.TransactionAmount[
                  info.row.original.TransactionAmount.length - 1
                ].TransactionAmount ?? '0',
              ),
            )}
          </div>
        );
      else return '';
    },
  },
  // {
  //   header: 'Loại tài khoản',
  //   accessorKey: 'AcctType',
  //   cell: (info) => {
  //     if (info.row.original.TransactionAcct.length > 0)
  //       return <div>{String(info.row.original.TransactionAcct[0].AcctType)}</div>;
  //     else return ''
  //   },
  // },
  {
    header: 'Nội dung',
    accessorKey: 'TransactionRemark',
  },
  {
    header: 'Thời gian chuyển',
    accessorKey: 'ValueDate',
  },
];

export const convertVariables = (variables: FilterType) => {
  const { fromTime, toTime, ...rest } = variables;

  const newTimeFrom =
    typeof fromTime === 'string' ? new Date(fromTime).getTime() : fromTime;
  const newTimeTo =
    typeof toTime === 'string' ? new Date(toTime).getTime() : toTime;

  return {
    ...rest,
    fromTime: fromTime ? formatDateTime(Number(newTimeFrom)) : '',
    toTime: toTime ? formatDateTime(Number(newTimeTo), true) : '',
  };
};

export const convertSelectStatusOptions = () => {
  return Object.keys(PointTransactionStatus).map((key: string) => {
    return {
      label: PointTransactionStatus[key as keyof typeof PointTransactionStatus],
      value: key,
    };
  });
};

export const convertSelectTransactionTypeOptions = () => {
  return Object.keys(PointTransactionTypes).map((key: string) => {
    return {
      label: PointTransactionTypes[key as keyof typeof PointTransactionTypes],
      value: key,
    };
  });
};
